import { useCallback, useEffect, useMemo } from "react";
import { useLocale, useService } from "../../../../hooks";

export const usePayment = () => {
  const { t } = useLocale();
  const { getLoggedInUserData, getUser, login } = useService("User");
  const { setTitle } = useService("Meta");
  const { urlToSplitData, getLocationData } = useService("Router");
  const { emptyCart, emptyOrder } = useService("Order");
  const status: number = 1;

  setTitle(t("paymentStatus"));

  const emptyOrderData = useCallback(() => {
    emptyCart();
    emptyOrder();
  }, [emptyCart, emptyOrder]);

  const updateUserData = useCallback(async () => {
    let query = {
      uid: getLoggedInUserData().uid,
    };
    const result = await getUser(query);
    if (result.status) {
      await login(result.data[0]);
      emptyOrderData();
    }
  }, [getLoggedInUserData, getUser, login, emptyOrderData]);

  useEffect(() => {
    updateUserData();
  }, [updateUserData]);

  const urlData = useMemo(
    () => urlToSplitData(getLocationData().pathname),
    [getLocationData, urlToSplitData]
  );
  return {
    status,
    urlData,
  };
};
